import { useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { SecureGate } from "@/components/SecureGate";

export function DeleteCantiereButton({ c, i, onDone }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const del = async () => {
    setBusy(true);
    try {
      const { data } = await api.delete(`/admin/cantieri/${c.series_id}`);
      toast.success(`Cantiere eliminato (${data.deleted} giorni rimossi)`);
      setOpen(false);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant="outline" className="rounded-full border-red-200 text-red-600" onClick={() => setOpen(true)} data-testid={`cantiere-delete-${i}`}><Trash2 className="h-4 w-4" /> Elimina</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="cantiere-delete-dialog">
          <DialogHeader><DialogTitle className="font-display">Elimina cantiere</DialogTitle></DialogHeader>
          <SecureGate description="Inserisci la seconda password per eliminare il cantiere. Resta sbloccata per 30 minuti.">
            <p className="text-sm text-slate-600">Il cantiere <b>{c.name}</b> verrà cancellato definitivamente con tutti i suoi giorni, rapportini e foto. La squadra riceverà un avviso. L'operazione non si può annullare.</p>
            <DialogFooter>
              <Button variant="outline" className="rounded-full" onClick={() => setOpen(false)}>Indietro</Button>
              <Button className="rounded-full bg-red-600 hover:bg-red-700" onClick={del} disabled={busy} data-testid="cantiere-delete-confirm">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Elimina definitivamente</Button>
            </DialogFooter>
          </SecureGate>
        </DialogContent>
      </Dialog>
    </>
  );
}
